export default __webpack_public_path__ + "static/media/kubernetesDark.d92572ab.svg";